<template>
  <accordion-section
    :open="section === 3"
    :valid="hasFullAddress"
    @selected="$emit('openSection', 3)"
  >
    <template #heading>
      Business Address
    </template>

    <div v-if="location.storefrontAddress">
      <div class="inputs">
        <custom-input
          v-for="(addressLine, index) in addressLines"
          :key="index"
          :label="index === 0 ? 'Enter your business address' : null"
          :placeholder="'Address line '+(index+1)"
          :value="addressLines[index]"
          :disabled="!canEditLocation"
          @input="updateAddressLineByIndex({value: $event.target.value, index})"
        />

        <div
          v-if="lastLineOfAddressHasValue && canEditLocation"
          class="addLine"
        >
          <button
            class="addLineBtn"
            @click="addAddressLine()"
          >
            + Add a line
          </button>
        </div>

        <custom-input
          v-model="locality"
          label="Town/City"
          placeholder="e.g. London"
          width="two-thirds"
          :disabled="!canEditLocation"
        />

        <custom-input
          v-model="postalCode"
          label="Postcode"
          placeholder="Zip/Postal Code"
          width="third"
          :disabled="!canEditLocation"
        />
      </div>

      <div class="recommendations">
        <span>Recommendations</span>
        <ul>
          <li>Only enter a physical address if customers actually visit your place of business.</li>
          <li>If you're based in the UK you do <strong>not</strong> need to add your county.</li>
        </ul>
      </div>
    </div>

    <div
      v-else
      class="no_address"
    >
      <p>
        You're location does not appear to have an address set with Google.
      </p>
      <p>
        We are currently unable to set an address for the first time via our platform.
      </p>
      <p>
        To add an address for your location, please go to
        <a
          href="https://business.google.com/"
          target="_blank"
        >Google Business Profile Manager</a>
      </p>
    </div>
  </accordion-section>
</template>

<script>
import AccordionSection from "../items/AccordionSection";
import {mapActions, mapGetters, mapMutations} from "vuex";
import CustomInput from "../../../../../views/reports/components/global/forms/CustomInput";

export default {
  components: {
    CustomInput,
    AccordionSection
  },
  props: {
    section: {
      type: Number,
      required: true,
    },
  },
  emits: ['openSection'],
  computed: {
    ...mapGetters('user', [
        'canEditLocation',
    ]),
    ...mapGetters('businessProfile', [
      'location',
      'addressLines'
    ]),
    locality: {
      get() {
        return this.$store.getters['businessProfile/locality'];
      },
      set(locality) {
        this.updateLocality(locality)
      }
    },
    postalCode: {
      get() {
        return this.$store.getters['businessProfile/postalCode'];
      },
      set(postalCode) {
        this.updatePostalCode(postalCode);
      }
    },
    lastLineOfAddressHasValue() {
      if (this.addressLines) {
        let lastIndex = this.addressLines.length - 1;
        return this.addressLines[lastIndex] !== '';
      }
      return false;
    },
    hasFullAddress() {
      return (
          !!this.addressLines &&
          !!this.addressLines[0] &&
          !!this.locality &&
          !!this.postalCode
      );
    }
  },
  methods: {
    ...mapMutations('editListing', [
      'setSelectedSection',
    ]),
    ...mapActions('businessProfile', [
      'addAddressLine',
      'updateAddressLineByIndex',
      'updateLocality',
      'updatePostalCode',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.inputs {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: -1.5rem;

  > .addLine {
    width: 100%;
    margin-top: -1rem;
    margin-bottom: .5rem;

    > .addLineBtn {
      color: #37B2A8;

      &:hover {
        color: #0A8080;
        text-decoration: underline;
      }
    }
  }
}

.no_address {
  padding: 0.5rem;
  border: 1px solid var(--negative-color);
  border-radius: 0.75rem;
  text-align: center;

  p {
    color: var(--negative-color);
    margin-bottom: .25rem;

    a {
      color: rgb(26, 13, 171);
    }
  }
}

</style>
